import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { remote_ml_asset_load_page_items } from '@/state/diffusion_models_ud/remote_ml_asset_load_page_items';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+diffusion_model/+ud/table/dto_diffusion_models_table_page_settings_ud';

export function WatcherDiffusionModelsLoadUD() {
  const dispatch = use_dispatch();

  const { current_table_page_settings, current_table, page_settings_loading_in_progress } = use_slice_ml_asset([
    'current_table_page_settings',
    'current_table',
    'page_settings_loading_in_progress',
  ]);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (current_table_page_settings.is_stub()) return; //nothing to load yet

    if (current_table_page_settings.index_page > 0) {
      void try_load_diffusion_models(current_table_page_settings.clone({ index_page: current_table_page_settings.index_page - 1 }));
    }

    void try_load_diffusion_models(current_table_page_settings);

    if (!current_table.is_stub() && current_table.get_total_pages_amount() > 1) {
      void try_load_diffusion_models(current_table_page_settings.clone({ index_page: current_table_page_settings.index_page + 1 }));
    }
  }, [current_table_page_settings]);

  /*
   * METHODS
   */

  async function try_load_diffusion_models(table_page_settings: DTODiffusionModelsTablePageSettingsUD) {
    let hash_crc32_page = table_page_settings.get_hash_crc32();
    if (page_settings_loading_in_progress.has(hash_crc32_page)) return; //loading in progress

    let hash_crc32_table = table_page_settings.get_hash_crc32_table();
    if (current_table.hash_crc32_settings_table == hash_crc32_table && current_table.pages_map.has(table_page_settings.index_page)) return; //already loaded

    await dispatch(remote_ml_asset_load_page_items(table_page_settings));
  }

  return null;
}
